import { render } from "./MTests.vue?vue&type=template&id=600cb7f3"
import script from "./MTests.vue?vue&type=script&lang=js"
export * from "./MTests.vue?vue&type=script&lang=js"

import "./MTests.vue?vue&type=style&index=0&id=600cb7f3&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__